import ErrorModal from 'components/ErrorModal';
import LoadingOverlay from 'components/LoadingOverlay';
import moment from 'moment';
import 'moment/locale/et';
import React, {useEffect, useState} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {TokenService} from 'services';
import {gsm} from 'utils/globalStateManager';
import PrivateRoute from 'views/auth/components/PrivateRoute';

const authPages = {
    forgotPassword: React.lazy(() => import ('views/auth/views/ForgotPassword')),
    restorePassword: React.lazy(() => import ('views/auth/views/RestorePassword')),
    login: React.lazy(() => import ('views/auth/views/Login')),
};

const pages = {
    aiAssistant: React.lazy(() => import('views/modules/aiAssistant')),
    profile: {
        profile: React.lazy(() => import('views/modules/profile/profile/Profile')),
        statistics: React.lazy(() => import('views/modules/profile/Statistics/Statistics')),
        comments: React.lazy(() => import('views/modules/profile/comments/Comments')),
    },
    manage: {
        fields: React.lazy(() => import('views/modules/manage/fields/Fields')),
    }
};
const layout = {
    company: React.lazy(() => import('views/layouts/MasterCRM/CompanyLayout')),
    manage: React.lazy(() => import('views/layouts/MasterCRM/ManageLayout')),
};
const App: React.FC = () => {
    moment.locale('et');
    const [isLoading, showLoading] = useState(true);
    gsm.withUseState(useState).init();

    useEffect(() => {
        if (isLoading) {
            const tokenService = new TokenService();
            const queryParams = new URLSearchParams(window.location.search);
            if (queryParams.has('tokenId')) {
                tokenService.getById(queryParams.get('tokenId') ?? '').then(token => {
                    TokenService.store(token);
                    showLoading(false);
                });
            }
            else {
                showLoading(false);
            }
        }
    }, []);

    if (isLoading) {
        return <div>laen...</div>;
    }

    document.getElementsByTagName('title')[0].innerHTML = 'CRM';
    const path = window.location.pathname;
    if (path.indexOf('/company') >= 0) {
        const pathRegex = /^\/company\/(\d+)/gm.exec(path);
        if (!pathRegex && !['/', '/login'].includes(path)) {
            return <div>Ettevõtte ID on puudu</div>;
        }
    }
    return (
        <React.Suspense fallback={<div>laen...</div>}>
            <BrowserRouter>
                <Routes>
                    <Route path="/forgotPassword" element={authPages.forgotPassword}/>
                    <Route path="/restorePassword/:code" element={authPages.restorePassword}/>
                    <Route path={'/login'} element={authPages.login}/>
                    <Route path={'/ai-assistant'} element={(
                        <PrivateRoute>
                            <pages.aiAssistant/>
                        </PrivateRoute>
                    )}/>
                    <Route path={'/company/:CID/profile/statistics/:subPage?'} element={(
                        <PrivateRoute>
                            <layout.company>
                                <pages.profile.statistics/>
                            </layout.company>
                        </PrivateRoute>
                    )}/>
                    <Route path={'/company/:CID/profile/:subPage?'} element={(
                        <PrivateRoute>
                            <layout.company>
                                <pages.profile.profile/>
                            </layout.company>
                        </PrivateRoute>
                    )}/>
                    <Route path={'/company/:CID/profile/comments/:subPage?'} element={(
                        <PrivateRoute>
                            <layout.company>
                                <pages.profile.comments/>
                            </layout.company>
                        </PrivateRoute>
                    )}/>

                    <Route path={'/manage/fields/:subPage?'} element={(
                        <PrivateRoute>
                            <layout.manage>
                                <pages.manage.fields/>
                            </layout.manage>
                        </PrivateRoute>
                    )}/>
                </Routes>
                <ErrorModal/>
                <LoadingOverlay/>
            </BrowserRouter>
        </React.Suspense>
    );
};

export default App;
